
annualSurveyForm = (moment, ModelService, ModelConfig) ->
    'ngInject'

    restrict: 'E'
    templateUrl: 'programs/annualSurvey/form'
    scope:
        program: '='
        survey: '='
        editable: '='

    link: (scope) ->
        survey = scope.survey
        scope.first_day = moment([survey.year - 1, 9, 1])
        scope.last_day = moment([survey.year, 8, 30])
        scope.config = ModelConfig.getModelDatapoints('annual_survey')

        scope.save = (data) ->
            ModelService.patchModel(survey, data)

        scope.totalUnits = ->
            scope.dybForm.housing_units_completed.activeData +
            scope.dybForm.housing_units_rehabed.activeData


module.directive 'annualSurveyForm', annualSurveyForm